(function () {
  'use strict';

  var ICONS = {"relax": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 2a7 7 0 00-7 7c0 4 3 6 3 9h8c0-3 3-5 3-9a7 7 0 00-7-7z\"/><line x1=\"9\" y1=\"21\" x2=\"15\" y2=\"21\"/><line x1=\"10\" y1=\"23\" x2=\"14\" y2=\"23\"/></svg>", "gift": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"8\" width=\"18\" height=\"4\" rx=\"1\"/><rect x=\"5\" y=\"12\" width=\"14\" height=\"9\" rx=\"1\"/><path d=\"M12 8v13\"/><path d=\"M8 8c0-2 1.5-4 4-4s4 2 4 4\"/></svg>", "luxury": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polygon points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"/></svg>", "energy": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 2L3 14h9l-1 8 10-12h-9l1-8z\"/></svg>", "sea": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\"><path d=\"M2 12c2-4 4-4 6 0s4 4 6 0 4-4 6 0\"/><path d=\"M2 17c2-4 4-4 6 0s4 4 6 0 4-4 6 0\"/></svg>", "forest": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2\"/><path d=\"M12 3c2 0 5 2 5 6s-3 6-5 6-5-2-5-6 3-6 5-6z\"/></svg>", "hotel": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 21h18M6 21V3h12v18M9 21v-4h6v4\"/><path d=\"M9 7h2M13 7h2M9 11h2M13 11h2\"/></svg>", "city": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z\"/><polyline points=\"9 22 9 12 15 12 15 22\"/></svg>", "calm": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><line x1=\"8\" y1=\"6\" x2=\"8\" y2=\"2\"/><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"2\"/><line x1=\"16\" y1=\"6\" x2=\"16\" y2=\"2\"/><path d=\"M6 12c0 4 2 6 2 8h8c0-2 2-4 2-8\"/><line x1=\"6\" y1=\"12\" x2=\"18\" y2=\"12\"/><rect x=\"8\" y=\"20\" width=\"8\" height=\"2\" rx=\"1\"/></svg>", "romantic": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z\"/></svg>", "bold": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 14.5A4.5 4.5 0 0012 21a4.5 4.5 0 004.5-4.5c0-2-.75-3.5-2.5-5-.5 1.5-.75 3-1.5 3-.5 0-1-.5-1-1.5 0-2-1-4.5-3-6 .5 3-2 5.5-2 7z\"/></svg>", "airy": "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"3\"/><path d=\"M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83\"/></svg>"};

  var QUESTIONS = [
    {
      id: 'mood',
      q: 'מה מניע אותך לחפש מפיץ ריח?',
      opts: [
        { id: 'relax',   text: 'רוצה שקט ורוגע',       scores: { hotel:2, fresh:1 } },
        { id: 'gift',    text: 'מחפש מתנה מיוחדת',     scores: { sweet:2, hotel:1 } },
        { id: 'luxury',  text: 'אוהב יוקרה ועיצוב',    scores: { hotel:3, masculine:1 } },
        { id: 'energy',  text: 'רוצה אנרגיה ורעננות',  scores: { fresh:3, fruity:1 } }
      ]
    },
    {
      id: 'place',
      q: 'באיזה מקום אתה הכי אוהב להיות?',
      opts: [
        { id: 'sea',    text: 'ליד הים',                scores: { fresh:3, hotel:1 } },
        { id: 'forest', text: 'בטבע ובין עצים',        scores: { masculine:2, fresh:1 } },
        { id: 'hotel',  text: 'בלובי מלון יוקרה',      scores: { hotel:3 } },
        { id: 'city',   text: 'בעיר, קפה ותרבות',     scores: { masculine:2, sweet:1 } }
      ]
    },
    {
      id: 'vibe',
      q: 'מה האווירה שאתה רוצה בבית?',
      opts: [
        { id: 'calm',     text: 'רגוע ומינימליסטי',   scores: { hotel:2, fresh:1 } },
        { id: 'romantic', text: 'רומנטי וחמים',        scores: { sweet:2, hotel:1 } },
        { id: 'bold',     text: 'אינטנסיבי וייחודי',  scores: { masculine:3 } },
        { id: 'airy',     text: 'נקי ופרחוני',         scores: { fresh:2, fruity:1 } }
      ]
    }
  ];

  var RECS = {
    hotel:     { handle:'four-seasons-premium', he:'פור סיזנס',   en:'Four Seasons',   notes:'יסמין · ארז · מוסק לבן',    mood:'יוקרתי, מרגיע',    accent:'#d4c4a8' },
    fresh:     { handle:'ocean-breeze',          he:'רוח ים',       en:'Ocean Breeze',   notes:'מי ים · אקליפטוס · נענע',   mood:'מרענן, קליל',       accent:'#88c8c0' },
    masculine: { handle:'oriental-spa-harmony',  he:'ספא מזרחי',   en:'Oriental Spa',   notes:'עוּד · פלפל · ענבר',        mood:'עמוק, ייחודי',      accent:'#c8a070' },
    sweet:     { handle:'royal-beach-premium',   he:'רויאל ביץ\'', en:'Royal Beach',    notes:'מי ים · אקווה · עץ סחף',    mood:'ים, חופש',          accent:'#a8c4d4' },
    fruity:    { handle:'beresheet-premium',     he:'בראשית',       en:'Beresheet',      notes:'ורד מדבר · עוּד · ענבר',    mood:'מסתורי, חמים',      accent:'#d4a888' }
  };

  function init() {
    var container = document.getElementById('snsei-quiz-inner');
    if (!container) return;

    var scores = { hotel:0, fresh:0, masculine:0, sweet:0, fruity:0 };
    var current = 0;

    function render() {
      if (current < QUESTIONS.length) {
        var q = QUESTIONS[current];
        var pct = Math.round((current / QUESTIONS.length) * 100);
        var optsHtml = q.opts.map(function(o) {
          return '<button class="snsei-quiz__opt" data-opt="' + o.id + '">' +
            '<span class="snsei-quiz__icon">' + (ICONS[o.id] || '') + '</span>' +
            '<span class="snsei-quiz__opt-text">' + o.text + '</span>' +
            '</button>';
        }).join('');

        container.innerHTML =
          '<div class="snsei-quiz__prog-wrap">' +
            '<span class="snsei-quiz__prog-label">שאלה ' + (current + 1) + ' מתוך ' + QUESTIONS.length + '</span>' +
            '<div class="snsei-quiz__prog-bar"><div class="snsei-quiz__prog-fill" style="width:' + pct + '%"></div></div>' +
          '</div>' +
          '<h3 class="snsei-quiz__q">' + q.q + '</h3>' +
          '<div class="snsei-quiz__opts">' + optsHtml + '</div>';

        container.querySelectorAll('.snsei-quiz__opt').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var opt = q.opts.filter(function(o) { return o.id === btn.dataset.opt; })[0];
            if (!opt) return;
            Object.keys(opt.scores).forEach(function(k) {
              scores[k] = (scores[k] || 0) + opt.scores[k];
            });
            btn.classList.add('chosen');
            setTimeout(function() { current++; render(); }, 350);
          });
        });
      } else {
        showResult();
      }
    }

    function showResult() {
      var winner = Object.keys(scores).sort(function(a,b){ return scores[b]-scores[a]; })[0];
      var rec = RECS[winner] || RECS.hotel;
      container.innerHTML =
        '<div class="snsei-quiz__result">' +
          '<div class="snsei-quiz__result-badge">הריח המושלם שלך</div>' +
          '<div class="snsei-quiz__result-bar" style="background:' + rec.accent + '"></div>' +
          '<h3 class="snsei-quiz__result-name">' + rec.he + '</h3>' +
          '<p class="snsei-quiz__result-en">' + rec.en + '</p>' +
          '<p class="snsei-quiz__result-notes">' + rec.notes + '</p>' +
          '<span class="snsei-quiz__result-mood">' + rec.mood + '</span>' +
          '<div class="snsei-quiz__result-btns">' +
            '<a class="snsei-quiz__buy-btn" href="/products/' + rec.handle + '">לצפייה ורכישה</a>' +
            '<a class="snsei-quiz__custom-btn" href="/pages/custom-diffuser">עיצוב אישי</a>' +
          '</div>' +
          '<button class="snsei-quiz__again" id="snsei-quiz-again">נסה שוב</button>' +
        '</div>';

      document.getElementById('snsei-quiz-again').addEventListener('click', function() {
        Object.keys(scores).forEach(function(k) { scores[k] = 0; });
        current = 0;
        render();
      });
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
